// extracted by mini-css-extract-plugin
export default {"root":"OverlayBackground_root__nEBX3","transparentTablet":"OverlayBackground_transparentTablet__EEce8"};